import React, { Component } from 'react';
import { Receipt } from '../services/smartparking-api';
import { formatISK } from '../services/utils/Prices';

import { Section, Header } from '../components/ui';
import logo from '../assets/img/logo.svg';

import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';

import concept from '../assets/img/airport-concept.png';

import ReactGA from 'react-ga';

import moment from 'moment';

import explainerImage from '../assets/img/brottfararhlid.png';
import MapImage from '../assets/img/map.jpg';
import SatelliteMapImage from '../assets/img/map_real.png';
import MapOverlay from '../assets/img/map_overlay.png';

class ReceiptView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            receipt: null,
            order: null,
            loading: true,
            satellite: false,
        };
    }

    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    async componentWillMount() {
        this.setState({ loading: true });
        Receipt.get(this.props.match.params.id)
            .then((res) => {
                console.log(res.data);
                this.setState({
                    receipt: res.data,
                    order: res.data.orderId,
                    loading: false,
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }

    toggleMap() {
        let { satellite } = this.state;
        satellite = !satellite;
        this.setState({ satellite });
        console.log(satellite);
    }

    render() {
        const { receipt, order, satellite } = this.state;
        return (
            <div>
                {!this.state.loading && (
                    <Header title={`Pöntun #${receipt.AuthCode}`} subtitle={''} concept={concept} logo={logo} />
                )}
                {this.state.loading ? (
                    <div className="loader">
                        <CircularProgress />
                    </div>
                ) : (
                    <div>
                        <div className="container">
                            {receipt.PaymentMethod && (
                                <Paper elevation={1} className="receipt">
                                    <div className="receiptHeader">
                                        <p>Lagning ehf.</p>
                                        <p>Suðurlandsbraut 30</p>
                                        <p>108 Reykjavík</p>
                                    </div>
                                    <h2>{receipt.PaymentMethod.CardType}</h2>
                                    <p>Færsluhirðir: SaltPay</p>
                                    <p>Dagssetning: {new Date(receipt.TransactionDate).toLocaleDateString()}</p>
                                    <p>Tími: {new Date(receipt.TransactionDate).toLocaleTimeString()}</p>
                                    <p>{receipt.PaymentMethod.PAN}</p>
                                    <p>NETGREIÐSLA</p>
                                    <Divider />
                                    <div className="priceTitle">
                                        <h2>ISK</h2>
                                        <h2>{formatISK(receipt.Amount)}</h2>
                                    </div>
                                    <p>Heimild: {receipt.AuthCode}</p>
                                    <p>Tilvísunarnúmer: {receipt.OrderId}</p>
                                    <em>Eintak korthafa</em>
                                </Paper>
                            )}
                            <Section title={'TAKK FYRIR AÐ BÓKA STÆÐIÐ!'} slim>
                                <div className="facts">
                                    <div className="fact">
                                        <p>Brottför</p>
                                        <h2>{moment(order.stay.departure).format('DD.MM.YYYY - HH:mm')}</h2>
                                    </div>
                                    <div className="fact">
                                        <p>Heimkoma</p>
                                        <h2>{moment(order.stay.arrival).format('DD.MM.YYYY - HH:mm')}</h2>
                                    </div>
                                    <div className="fact">
                                        <p>Lengd geymslu</p>
                                        <h2>{order.stay.duration} dagar</h2>
                                    </div>
                                    <div className="fact">
                                        <p>Bílnúmer</p>
                                        <h2>{order.vehicle.reg}</h2>
                                    </div>
                                    <div className="fact hide"></div>
                                    <div className="fact hide"></div>
                                    <div className="fact hide"></div>
                                </div>
                                <p style={{ textAlign: 'justify' }}>
                                    Við höfum nú móttekið skráninguna þína og komum til með að fara vel yfir hana, starfsmaður frá
                                    Lagningu kemur til með að sækja bifreiðina þína á Keflavíkurflugvöll við brottfararhlið.{' '}
                                    <b>
                                        ATH ekki þarf að leggja bílnum í skammtíma- eða langtímastæði fyrir utan flugvöllinn þegar
                                        bílnum er komið til okkar.
                                    </b>
                                </p>
                                <p style={{ textAlign: 'justify' }}>
                                    Þú getur einnig sent okkur SMS í símanúmerið 778-5999 ef aðstæður breytast og þú þarft að
                                    seinka eða flýta komu þinni hvort sem það er við brottför eða komu. –{' '}
                                    <b>Endilega hringdu í okkur þegar það eru 15-20 mín í þig.</b>
                                </p>
                                <p style={{ textAlign: 'justify' }}>
                                    Hér fyrir neðan má sjá mynd af því hvar brottfararhliðið er og gættu þess að keyra á innri
                                    akrein þegar þú kemur þar sem rútur eiga greiðan aðgang að ytri akrein brottfarahliðsins.
                                </p>

                                <div className="mapImage">
                                    <img src={MapOverlay} alt="" />
                                    <img src={satellite ? SatelliteMapImage : MapImage} alt="" />
                                </div>
                                <div className="centerButton">
                                    <Button variant="contained" className={'mapButton'} onClick={(e) => this.toggleMap()}>
                                        {satellite ? 'Kort' : 'Loftmynd'}
                                    </Button>
                                </div>

                                <p style={{ textAlign: 'justify' }}>
                                    Við heimkomu skaltu hringja í okkur þegar að þú ert að bíða eftir töskum eða komin/n í
                                    fríhöfnina.
                                </p>
                            </Section>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default ReceiptView;



// WEBPACK FOOTER //
// ./src/views/Receipt.js